module.exports = __webpack_public_path__ + "bb54987eae12858e29b383b0b0a9687c.png";